import { render, staticRenderFns } from "./EducationWidget.vue?vue&type=template&id=62cc6f80"
import script from "./EducationWidget.vue?vue&type=script&lang=js"
export * from "./EducationWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports